module.exports = __webpack_public_path__ + "/img/squirrel-gesturing.ed063316c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/squirrel-gesturing.svg
// module id = 1398
// module chunks = 0